module.exports = __webpack_public_path__ + "static/img/15.6f23e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/15.png
// module id = KRIL
// module chunks = 0